module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/employer/templates/employee/DefaultPayrollDetail.ejs -->\n<td class="title td-nowrap">\n    <strong>\n        '+
((__t=( model.getPayrollItemName() ))==null?'':_.escape(__t))+
'\n        <small>\n            ';
 if (
                model.getPayrollItemType() !== 'unpaid_leave' &&
                model.getPayrollItemType() !== 'overtime' &&
                model.get('additionalInformation')
            ) { 
__p+='\n                ';
 info = model.get('additionalInformation'); 
__p+='\n                (\n                    ';
 last = _.last(_.keys(info)); 
__p+='\n                    ';
 _.each(_.keys(info), function(attr, i) { 
__p+='\n                        '+
((__t=( info[attr] + (attr !== last ? ', ' : '') ))==null?'':_.escape(__t))+
'\n                    ';
 }); 
__p+='\n                )\n            ';
 } 
__p+='\n            ';
 if (
                model.isOvertime() &&
                model.get('additionalInformation')
            ) { 
__p+='\n                ';
 info = model.get('additionalInformation'); 
__p+='\n                (\n                    Hourly wage: '+
((__t=( info.hourlyWage ))==null?'':_.escape(__t))+
',\n                    Rate: '+
((__t=( info.overtimeFactor ))==null?'':_.escape(__t))+
'x\n                )\n            ';
 } 
__p+='\n        </small>\n    </strong>\n    <a href="" class="js-destroy" tabindex="-1">\n        <i class="fa fa-times"></i>\n    </a>\n    <span class="error error-rate error-unit error-amount"></span>\n    <span class="error error-rate error-unit error-amount\n        error-placeholder"></span>\n</td>\n\n';
 if (model.isUnit()) { 
__p+='\n    <td class="form-group">\n        <span>'+
((__t=( model.isOvertime() ? 'Rate' : 'RM' ))==null?'':_.escape(__t))+
':</span>\n        <input name="rate" class="form-control form-control-invisible"\n            autocomplete="off" type="text"\n            value="'+
((__t=( (model.get('rate') || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
'"\n            data-value-type="float"\n            '+
((__t=( model.isOvertime() ? 'readonly' : '' ))==null?'':_.escape(__t))+
'\n            >\n    </td>\n    <td class="form-group">\n        <span>'+
((__t=( model.isOvertime() ? 'Hours' : 'Units' ))==null?'':_.escape(__t))+
':</span>\n        <input name="unit" class="form-control form-control-invisible"\n            autocomplete="off" type="text"\n            value="'+
((__t=( (model.get('unit') || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
'"\n            data-value-type="float">\n    </td>\n';
 } else { 
__p+='\n    <td></td>\n    <td></td>\n';
 } 
__p+='\n\n<td class="form-group">\n    <input name="amount"\n        class="form-control text-right form-control-invisible"\n        type="text" autocomplete="off"\n        '+
((__t=( (model.isUnit()) ? 'readonly' : '' ))==null?'':_.escape(__t))+
'\n        value="'+
((__t=( (model.get('amount') || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
'"\n        data-value-type="float">\n</td>\n\n';
 if (model.isAllowUnpaidLeave()) { 
__p+='\n    <td class="form-group text-center">\n        <input name="isUnpaidLeave" class="form-control js-icheck"\n            type="checkbox" autocomplete="off"\n            data-value-type="boolean"\n            '+
((__t=( (model.get('isUnpaidLeave') || false) ? 'checked' : '' ))==null?'':_.escape(__t))+
'>\n    </td>\n';
 } else { 
__p+='\n    <td></td>\n';
 } 
__p+='\n\n';
 if (model.isAllowAffectOvertime()) { 
__p+='\n    <td class="form-group text-center">\n        <input name="isAffectOvertime" class="form-control js-icheck"\n               type="checkbox" autocomplete="off"\n               data-value-type="boolean"\n               '+
((__t=( (model.get('isAffectOvertime') || false) ? 'checked' : '' ))==null?'':_.escape(__t))+
'>\n    </td>\n';
 } else { 
__p+='\n    <td></td>\n';
 } 
__p+='\n\n<td class="form-group text-center">\n    <input name="isProratable" class="form-control js-icheck"\n           type="checkbox" autocomplete="off"\n           data-value-type="boolean"\n           '+
((__t=( (model.get('isProratable') || false) ? 'checked' : '' ))==null?'':_.escape(__t))+
'>\n</td>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/employer/templates/employee/DefaultPayrollDetail.ejs
// module id = 793
// module chunks = 1